module.exports = __webpack_public_path__ + "media/images/apple-e4ae7e28eaaff70256382604927c819a.svg";